module.exports = __webpack_public_path__ + "img/time-intro.0007654a.png";